import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { SiteFooter } from '@/components/generals/site-footer'
import { SiteHeader } from '@/components/generals/site-header'

interface PageLayoutProps extends LayoutProps {
    clock?: boolean
}

export const Layout: FC<PageLayoutProps> = ({ children, clock = false }): ReactNode => {
    return (
        <div className='relative w-full'>
            <a
                href='#main-content'
                className='fixed left-4 top-4 z-[90] -translate-y-24 bg-ink px-4 py-3 font-mono text-xs uppercase tracking-[0.18em] text-ivory transition-transform focus:translate-y-0'
            >
                Skip to content
            </a>

            <SiteHeader clock={clock} />

            <main id='main-content' className='relative z-10 bg-tone shadow-[0_40px_80px_-30px_rgb(0_0_0/0.45)]'>
                {children}
            </main>

            <SiteFooter />
        </div>
    )
}
